// react
import { useContext } from 'react';

// context
import { ContextSupplierActs } from '../Supplier.context';

// mui
import { Container, Grid } from '@mui/material';

// tables
import { TableActs } from '../../../tables/cards/TableActs/TableActs';

export const Activities = () => {
	// context
	const { acts, isLoadingActs, paginationActs } = useContext(ContextSupplierActs);

	return (
		<section>
			<Container maxWidth={false}>
				<Grid container spacing={2}>
					<Grid item xs={12}>
						<TableActs acts={acts} isLoading={isLoadingActs} pagination={paginationActs} />
					</Grid>
				</Grid>
			</Container>
		</section>
	);
};
